import React, { Component } from 'react';
import { Scoped, k, m } from 'kremling';
import { debounce } from 'lodash';
import { PageHeader } from '../../components/page-header/page-header';
import { Calendar } from 'components/calendar/calendar.component';
import { Button } from '../../components/button/button.component';
import { Dropdown } from 'components/dropdown/dropdown.component';
import { userState, hasPermission } from '../../shared/user-state';
import { getCompany, patchCompany, getBrands, getNAICS, getCompanyStatuses, getCompanyCancelReasons, getAccounts, getUsers, duplicateCompany } from '../../shared/common.api';
import { Save } from '../../components/save/save.component';
import { Status } from '../../components/status/status.component';
import { Loader } from '../../components/loader/loader.component';
import TimeSelector from '../../components/time-selector/time-selector.component';
import { ModalDialog } from '../../components/modal/modal-dialog.component';
import { AsyncModalDialog } from '../../components/modal/async-modal-dialog.component';
import moment from 'moment-timezone';
import { DynamicTypeAhead } from '../../components/dynamic-type-ahead/dynamic-type-ahead.component';
import { StaticTypeAhead } from '../../components/static-type-ahead/static-type-ahead.componet';
import _ from 'lodash';
import { ColorPicker, ModalFileViewer, Toggle } from 'components';
import utils from '../../shared/utils';
export class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      company: {},
      brands: [],
      naics: [],
      companyStatuses: [],
      users: [],
      accounts: [],
      companyCancelReasons: [],
      activeModal: false,
      errors: {},
      openModalDuplicate: false,
      newCompany: {
        newCompanyName: '',
        journeys: true,
        templates: true,
        segments: true,
        dataFields: true,
        savedBlocks: true,
        usersAndRoles: false
      },
      showFileViewer: false
    };
  }
  componentDidMount() {
    getCompany(this.props.match.params.id).then(companyRes => {
      const company = companyRes.data;
      company.phone = utils.formatPhoneNumber(company.phone) || company.phone;
      this.setState({
        loading: false,
        company,
        companyAsId: userState.getAsCompanyId()
      });
    });
    if (userState.state.user.is_superuser) {
      Promise.all([getCompanyStatuses(this.props.match.params.id), getBrands(), getNAICS(), getUsers({
        limit: 1000
      }), getAccounts(), getCompanyCancelReasons()]).then(([companyStatusesRes, brandRes, NAICSRes, UsersRes, accountsRes, companyCancelReasonRes]) => {
        this.setState({
          loading: false,
          companyStatuses: companyStatusesRes.data.results,
          brands: brandRes.data.results,
          naics: NAICSRes.data.results,
          users: UsersRes.data.results,
          accounts: accountsRes.data.results,
          companyCancelReasons: companyCancelReasonRes.data.results,
          companyAsId: userState.getAsCompanyId()
        });
      });
    }
    this.asCompanyObservable = userState.subscribe(({
      asCompany
    }) => {
      if (asCompany) {
        this.setState({
          companyAsId: asCompany.id
        });
      }
    }, 'asCompany');
  }
  visualSave = () => {
    return new Promise(resolve => {
      this.visualSaveTimeout = setTimeout(() => {
        resolve();
      }, 1000);
    });
  };
  componentWillUnmount() {
    clearTimeout(this.visualSaveTimeout);
    this.asCompanyObservable.unsubscribe();
  }
  save = debounce(() => {
    const {
      id,
      ...data
    } = this.state.company;
    if (data.email_suppress_bounces === '') {
      data.email_suppress_bounces = null;
    }
    if (data.email_suppress_days === '') {
      data.email_suppress_days = null;
    }
    if (data.email_suppress_unopens === '') {
      data.email_suppress_unopens = null;
    }
    this.setState({
      saving: true,
      errors: {}
    });
    Promise.all([patchCompany(id, data), this.visualSave()]).then(([{
      data: company
    }, ...args]) => {
      if (userState.state.asCompany.id === company.id) {
        userState.setAsCompany(company);
      }
      this.setState({
        saving: false
      });
    }).catch(patchError => {
      this.setState({
        errors: patchError.response.data,
        saving: false
      });
    });
  }, 1000);
  update = (key, val) => {
    this.setState({
      company: {
        ...this.state.company,
        [key]: val
      }
    }, this.save);
  };
  handleDuplicateCompany = () => {
    const {
      newCompany,
      company
    } = this.state;
    return duplicateCompany({
      name: newCompany.newCompanyName,
      status: newCompany.newCompanyStatus,
      account_manager: newCompany.newCompanyAccountManager,
      contract_original_signed_date: newCompany.newCompanyContractSignedDate ? newCompany.newCompanyContractSignedDate.format('YYYY-MM-DD') : null,
      contract_signed_mrr: newCompany.newCompanyContractSignedMRR,
      journeys: newCompany.journeys,
      templates: newCompany.templates,
      segments: newCompany.segments,
      data_fields: newCompany.dataFields,
      saved_blocks: newCompany.savedBlocks,
      user_roles: newCompany.usersAndRoles
    }, company.id);
  };
  render() {
    const {
      loading,
      brands,
      company,
      activeModal,
      companyAsId,
      saving,
      naics,
      companyStatuses,
      users,
      accounts,
      companyCancelReasons,
      errors,
      newCompany,
      openModalDuplicate,
      showFileViewer
    } = this.state;
    const selectedBrand = brands.find(brand => brand.id === company.brand);
    const selectedAccountManager = users.find(user => user.id === company.account_manager);
    const selectedBillingContact = users.find(user => user.id === company.billing_contact);
    const selectedPrimaryContact = users.find(user => user.id === company.primary_contact);
    const selectedAccountId = accounts.find(account => account.id === company.account);
    const selectedStatusId = companyStatuses.find(statuses => statuses.id === company.status);
    const selectedCompanyCancelReason = companyCancelReasons.find(companyCancelReason => companyCancelReason.name === company.companyCancelReason);
    const selectedNAICS = naics.find(naics => naics.id === company.naics);
    const workingAs = companyAsId === company.id;
    const canEdit = company && hasPermission(userState.state.user, company.id, 'organization.change_company');
    const timezone = moment.tz.names().map(t => {
      return {
        id: t,
        value: t
      };
    });
    return <Scoped css={css}>
        <div className="wrapper">
          {loading && <Loader overlay background="#fff" />}
          <PageHeader name={company.name || ''} updateName={canEdit ? name => this.update('name', name) : null} actions={<>
                <Save saving={saving} />
                {userState.state.user.is_superuser && <Button onClick={() => this.setState({
            openModalDuplicate: true
          })}>Duplicate</Button>}
                {workingAs ? <Status data-cy="btn-work-as" type="success">
                    Working As
                  </Status> : <Button data-cy="btn-work-as" onClick={() => userState.setAsCompany(company)}>
                    Work as this company
                  </Button>}
                {userState.state.user.is_superuser && <div className="toggler">
                    <Button className={m('active', company.is_active)} onClick={company.is_active ? () => {} : () => this.setState({
              activeModal: true
            })}>
                      Active
                    </Button>
                    <Button className={m('active', !company.is_active)} onClick={company.is_active ? () => this.setState({
              activeModal: true
            }) : () => {}}>
                      Inactive
                    </Button>
                  </div>}
              </>} />
          {company.id && <div className="company-list">
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Address 1</label>
                    <input onChange={e => this.update('address1', e.target.value)} className="form-control" type="text" disabled={!canEdit} value={company.address1 || ''} />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Address 2</label>
                    <input onChange={e => this.update('address2', e.target.value)} className="form-control" type="text" disabled={!canEdit} value={company.address2 || ''} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>City</label>
                    <input onChange={e => this.update('city', e.target.value)} className="form-control" type="text" disabled={!canEdit} value={company.city || ''} />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>State</label>
                    <input onChange={e => this.update('state', e.target.value)} className="form-control" type="text" disabled={!canEdit} value={company.state || ''} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Zip</label>
                    <input onChange={e => this.update('zip_code', e.target.value)} className="form-control" type="number" disabled={!canEdit} value={company.zip_code || ''} />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Phone</label>
                    <input onChange={e => this.update('phone', e.target.value)} className="form-control" type="phone" disabled={!canEdit} value={company.phone || ''} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Mail Return Address</label>
                    <select value={company.use_mailhouse_return_address} className="form-control" disabled={!canEdit} onChange={e => this.update('use_mailhouse_return_address', e.target.value === 'true')}>
                      <option value="true">Mail House address</option>
                      <option value="false">Company address</option>
                    </select>
                    <div className="text-sm mt-sm">
                      {company.use_mailhouse_return_address ? <em>(Your business will not need to worry about receiving any of the return mail)</em> : <em>(As listed on this page)</em>}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Timezone</label>
                    <StaticTypeAhead items={timezone} placeholder={company.timezone ? company.timezone : 'Choose Timezone'} displayProperty="value" keyProperty="id" value={company ? company.timezone : ''} onChange={timezone => timezone && this.update('timezone', timezone.value)} />
                    {errors.timezone && errors.timezone.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Default Email Address</label>
                    <input onChange={e => this.update('default_email', e.target.value)} className="form-control" type="email" disabled={!canEdit} value={company.default_email || ''} />
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Default From Name</label>
                    <input onChange={e => this.update('default_from_name', e.target.value)} className="form-control" type="text" disabled={!canEdit} value={company.default_from_name || ''} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Require Two-factor Authentication</label>
                    <Toggle className="ml-3" disabled={!canEdit} checked={!!company.require_mfa} onToggle={() => {
                  this.update('require_mfa', !company.require_mfa);
                }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Logo</label>
                    <div>
                      {company.company_logo && <img onClick={() => {
                    if (canEdit) this.setState({
                      showFileViewer: true
                    });
                  }} src={company.company_logo} height="50px" />}
                      {!company.company_logo && canEdit && <Button onClick={() => this.setState({
                    showFileViewer: true
                  })}>Add Logo</Button>}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Primary Color</label>
                    <ColorPicker disabled={!canEdit} color={company ? company.primary_color : null} onChange={color => this.update('primary_color', color)} />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <label>Secondary Color</label>
                    <ColorPicker disabled={!canEdit} color={company ? company.secondary_color : null} onChange={color => this.update('secondary_color', color)} />
                  </div>
                </div>
              </div>
              <hr />
              {userState.state.user.is_superuser && <>
                  <div className="col-12 my-5">
                    <strong>Admin Settings</strong>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Status ID</label>
                        <DynamicTypeAhead getItems={getCompanyStatuses} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} placeholder={selectedStatusId ? `${selectedStatusId.name}` : 'Select a Status ID'} displayProperty="name" keyProperty="id" value={selectedStatusId ? selectedStatusId.id : null} onChange={statusId => {
                    this.update('status', statusId ? statusId.id : statusId);
                  }} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Account Manager</label>
                        <DynamicTypeAhead getItems={getUsers} placeholder={selectedAccountManager ? `${selectedAccountManager.email}` : 'Select an Account Manager'} displayProperty="email" keyProperty="id" value={selectedAccountManager ? selectedAccountManager.id : null} onChange={user => {
                    this.update('account_manager', user ? user.id : null);
                  }} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Account ID</label>
                        <DynamicTypeAhead getItems={getAccounts} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} placeholder={selectedAccountId ? `${selectedAccountId.name}` : 'Select a Account ID'} displayProperty="name" keyProperty="id" value={selectedAccountId ? selectedAccountId.id : null} onChange={account => {
                    this.update('account', account ? account.id : account);
                  }} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Brand</label>
                        <DynamicTypeAhead getItems={getBrands} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} placeholder={selectedBrand ? `${selectedBrand.name}` : 'Select a Brand'} displayProperty="name" keyProperty="id" value={selectedBrand ? selectedBrand.id : null} onChange={brand => {
                    this.update('brand', brand ? brand.id : brand);
                  }} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Industry</label>
                        <DynamicTypeAhead getItems={getNAICS} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} placeholder={selectedNAICS ? `${selectedNAICS.title}` : 'Select an Industry'} displayProperty="title" keyProperty="id" value={selectedNAICS ? selectedNAICS.id : null} onChange={naic => {
                    this.update('naics', naic ? naic.id : naic);
                  }} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Contract Original Signed</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.contract_original_signed_date ? moment(company.contract_original_signed_date).format('MM/DD/YYYY') : 'Select Contract Original Signed'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.contract_original_signed_date ? new Date(company.contract_original_signed_date) : null} onChange={date => {
                      this.update('contract_original_signed_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Contract Signed MRR</label>
                        <input type="number" className="form-control" onChange={e => this.update('contract_signed_mrr', e.target.value)} value={company.contract_signed_mrr ? company.contract_signed_mrr : ''} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Billed First Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.billed_first_date ? moment(company.billed_first_date).format('MM/DD/YYYY') : 'Select Billed First Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.billed_first_date ? new Date(company.billed_first_date) : null} onChange={date => {
                      this.update('billed_first_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Cancel Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.cancel_date ? moment(company.cancel_date).format('MM/DD/YYYY') : 'Select Cancel Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.cancel_date ? new Date(company.cancel_date) : null} onChange={date => {
                      this.update('cancel_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Cancel Reason ID</label>
                        <DynamicTypeAhead getItems={getCompanyCancelReasons} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} placeholder={selectedCompanyCancelReason ? `${selectedCompanyCancelReason.name}` : 'Select a Cancel Reason Id'} displayProperty="name" keyProperty="id" value={selectedCompanyCancelReason ? selectedCompanyCancelReason.id : null} onChange={cancelReason => {
                    this.update('company_cancel_reason', cancelReason ? cancelReason.id : cancelReason);
                  }} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Billed Last Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.billed_last_date ? moment(company.billed_last_date).format('MM/DD/YYYY') : 'Select Billed Last Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.billed_last_date ? new Date(company.billed_last_date) : null} onChange={date => {
                      this.update('billed_last_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Customer End Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.customer_end_date ? moment(company.customer_end_date).format('MM/DD/YYYY') : 'Select Customer End Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.customer_end_date ? new Date(company.customer_end_date) : null} onChange={date => {
                      this.update('customer_end_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Entity Data</label>
                        <textarea className="form-control" rows={10} onChange={e => this.update('entity_data', e.target.value)} value={company.entity_data ? company.entity_data : ''} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Cohort Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.cohort_date ? moment(company.cohort_date).format('MM/DD/YYYY') : 'Select Cohort Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.cohort_date ? new Date(company.cohort_date) : null} onChange={date => {
                      this.update('cohort_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Commission End Date</label>
                        <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                              {company.commission_end_date ? moment(company.commission_end_date).format('MM/DD/YYYY') : 'Select Commission End Date'}
                            </Button>} content={({
                    close
                  }) => <div className="p-sm">
                              <Calendar value={company.commission_end_date ? new Date(company.commission_end_date) : null} onChange={date => {
                      this.update('commission_end_date', moment(date).format('YYYY-MM-DD'));
                      close();
                    }} />
                            </div>} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Commission Percent</label>
                        <input type="number" className="form-control" onChange={e => this.update('commission_percent', e.target.value)} value={company.commission_percent ? company.commission_percent : ''} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Contract Closer</label>
                        <input type="text" className="form-control" onChange={e => this.update('contract_closer', e.target.value)} value={company.contract_closer ? company.contract_closer : ''} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Freshsales ID</label>
                        <input type="text" className="form-control" onChange={e => this.update('freshsales_id', e.target.value)} value={company.freshsales_id ? company.freshsales_id : ''} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Lead Source</label>
                        <input type="text" className="form-control" onChange={e => this.update('lead_source', e.target.value)} value={company.lead_source ? company.lead_source : ''} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Mail Limit</label>
                        <input type="text" className="form-control" onChange={e => this.update('mail_limit', e.target.value)} value={company.mail_limit ? company.mail_limit : ''} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>SMS Limit</label>
                        <input type="text" className="form-control" onChange={e => this.update('sms_limit', e.target.value)} value={company.sms_limit ? company.sms_limit : ''} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label>Billing Contact</label>
                        <DynamicTypeAhead getItems={getUsers} placeholder="Select an Billing Contact" displayProperty="email" keyProperty="id" value={company.billing_contact} onChange={user => {
                    this.update('billing_contact', user ? user.id : null);
                  }} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Primary Contact</label>
                        <DynamicTypeAhead getItems={getUsers} placeholder="Select an Primary Contact" displayProperty="email" keyProperty="id" value={company.primary_contact ? company.primary_contact : null} onChange={user => {
                    this.update('primary_contact', user ? user.id : null);
                  }} getItemsFilters={{
                    company: userState.getAsCompanyId()
                  }} />
                      </div>
                    </div>
                  </div>
                  <hr />
                </>}
              <div className="row">
                <div className="col-12 my-5">
                  <strong>MMS Throttling Settings</strong>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Messages Per Minute Per Phone</label>
                    <input onChange={e => this.update('mms_mpm', e.target.value)} className="form-control" type="number" disabled={!canEdit} value={company.mms_mpm || ''} />
                    {errors.mms_mpm && errors.mms_mpm.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                    {!errors.mms_mpm && <div className="text-sm mt-sm">Maximum number of MMS messages to send per minute per phone number.</div>}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Maximum Wait Time</label>
                    <input onChange={e => this.update('mms_max_wait', e.target.value)} disabled={!canEdit} className="form-control" type="number" value={company.mms_max_wait || ''} />
                    {errors.mms_max_wait && errors.mms_max_wait.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                    {!errors.mms_max_wait && <div className="text-sm mt-sm">Maximum amount of time in minutes to keep messages in the queue</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <strong>Send Time Window</strong>
                  <div className="text-sm mb-sm">Use the settings below to set the allowed time window for sending MMS messages.</div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Start Time</label>
                    <TimeSelector value={company.mms_send_start || ''} disabled={!canEdit} onChange={e => this.update('mms_send_start', e)} />
                    {errors.mms_send_start && errors.mms_send_start.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>End Time</label>
                    <TimeSelector value={company.mms_send_end || ''} disabled={!canEdit} onChange={e => this.update('mms_send_end', e)} />
                    {errors.mms_send_end && errors.mms_send_end.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-12 my-5">
                  <strong>Email Suppression Settings</strong>
                </div>
              </div>
              <div className="row">
                <div className="col-12 my-5">
                  Suppressed email addresses will block sending to those addresses. Failed email attempts may still be charged as if the
                  message was successful. Addresses are automatically un-suppressed if the customer appears in a new transaction.
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Bounced Messages Threshold</label>
                    <input onChange={e => this.update('email_suppress_bounces', e.target.value)} className="form-control" disabled={!canEdit} type="number" value={company.email_suppress_bounces || ''} />
                    {errors.email_suppress_bounces && errors.email_suppress_bounces.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                    {!errors.email_suppress_bounces && <div className="text-sm mt-sm">
                        Number of consecutive failed send attempts for a customer's email address to be marked bad.
                      </div>}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label>Unopened Messages Threshold</label>
                    <input onChange={e => this.update('email_suppress_unopens', e.target.value)} className="form-control" disabled={!canEdit} type="number" value={company.email_suppress_unopens || ''} />
                    {errors.email_suppress_unopens && errors.email_suppress_unopens.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                    {!errors.email_suppress_unopens && <div className="text-sm mt-sm">
                        Number of consecutive unopened messages for a customer's email address to be marked bad.
                      </div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Unopened Days Threshold</label>
                    <input onChange={e => this.update('email_suppress_days', e.target.value)} className="form-control" disabled={!canEdit} type="number" value={company.email_suppress_days || ''} />
                    {errors.email_suppress_days && errors.email_suppress_days.map((error, i) => <p key={i} className="pt-sm invalid-input">
                          {error}
                        </p>)}
                    {!errors.email_suppress_days && <div className="text-sm mt-sm">
                        Number of consecutive days a message has not been opened for a customer's email address to be marked bad.
                      </div>}
                  </div>
                </div>
              </div>
            </div>}

          <ModalDialog open={activeModal} onClose={() => this.setState({
          activeModal: false
        })} allowBackdropClick title={`${company.is_active ? 'Deactivate' : 'Activate'} Company`} onSubmit={() => this.update('is_active', !company.is_active)} submitText={company.is_active ? 'Deactivate' : 'Activate'}>
            Are you sure you want to {company.is_active ? 'deactivate' : 'activate'} this company?
          </ModalDialog>
          <ModalDialog open={openModalDuplicate} onClose={() => this.setState({
          openModalDuplicate: false
        })} allowBackdropClick title={`Duplicate Company`} onSubmit={this.handleDuplicateCompany} submitText="Create Company" submitDisabled={!newCompany.newCompanyName || !newCompany.newCompanyStatus}>
            <div className="form-group mb-sm">
              <label>New Company Name</label>
              <input className="form-control" name="newCompanyName" defaultValue={''} onChange={e => this.setState({
              newCompany: {
                ...newCompany,
                newCompanyName: e.target.value
              }
            })} />
            </div>

            <div className="form-group">
              <label>
                Status <span className="form-error">*</span>
              </label>
              <DynamicTypeAhead getItems={getCompanyStatuses} placeholder="Choose Company Status" displayProperty="name" keyProperty="id" value={newCompany.newCompanyStatus || null} onChange={manager => this.setState({
              newCompany: {
                ...newCompany,
                newCompanyStatus: manager.id
              }
            })} />
            </div>
            <div className="form-group">
              <label>Account Manager</label>
              <DynamicTypeAhead getItems={getUsers} placeholder="Choose Account Manager" displayProperty="email" keyProperty="id" value={newCompany.newCompanyAccountManager || null} onChange={manager => this.setState({
              newCompany: {
                ...newCompany,
                newCompanyAccountManager: manager ? manager.id : null
              }
            })} />
            </div>
            <div className="form-group">
              <label>Contract Signed Date</label>
              <Dropdown size="md" allowContentClicks trigger={() => <Button dropdown block>
                    {newCompany.newCompanyContractSignedDate ? newCompany.newCompanyContractSignedDate.format('LL') : 'Select Date'}
                  </Button>} content={({
              close
            }) => <div className="p-sm">
                    <Calendar minDate={this.minDate} value={newCompany.newCompanyContractSignedDate ? newCompany.newCompanyContractSignedDate.toDate() : null} onChange={date => {
                this.setState({
                  newCompany: {
                    ...newCompany,
                    newCompanyContractSignedDate: moment(date)
                  }
                });
                close();
              }} />
                  </div>} />
            </div>
            <div className="form-group">
              <label>Contract Signed MRR</label>
              <input type="text" className="form-control" value={newCompany.newCompanyContractSignedMRR} onChange={e => this.setState({
              newCompany: {
                ...newCompany,
                newCompanyContractSignedMRR: e.target.value
              }
            })} />
            </div>

            <div>
              <ul className="select-list mt-4 ml-2">
                {['journeys', 'templates', 'segments', 'dataFields', 'savedBlocks', 'usersAndRoles'].map((field, i) => {
                return <li key={i}>
                      <div className="checkbox-label">
                        <label className="form-check-label">
                          <input className="form-check-input" name={field} style={{
                        position: 'relative',
                        top: '1px',
                        transform: 'scale(1.25)'
                      }} type="checkbox" onChange={e => this.setState({
                        newCompany: {
                          ...newCompany,
                          [e.target.name]: !newCompany[e.target.name]
                        }
                      })} checked={newCompany && newCompany[field]} />
                          {_.startCase(field)}
                        </label>
                      </div>
                    </li>;
              })}
              </ul>
            </div>
          </ModalDialog>
          <ModalFileViewer open={showFileViewer} onSubmit={file => this.update('company_logo', file.url)} onClose={() => this.setState({
          showFileViewer: false
        })} />
        </div>
      </Scoped>;
  }
}
const css = {
  styles: `[kremling="i11"] body,body[kremling="i11"] {
  --color-primary: #487aae;
  --color-highlight: #e7efff;
  --color-accent: #354052;
  --color-success: #73b56e;
  --color-warning: #f4b707;
  --color-danger: #df5651;
  --color-grey-10: #f9f9f9;
  --color-grey-25: #f3f3f3;
  --color-grey-50: #e9e9e9;
  --color-grey-75: #e3e3e3;
  --color-grey-100: #d3d3d3;
  --color-grey-200: #c3c3c3;
  --color-grey-300: #b3b3b3;
  --color-grey-400: #a3a3a3;
  --color-grey-500: #808080;
  --color-grey-600: #707070;
  --color-grey-700: #606060;
  --color-grey-800: #505050;
  --color-grey-900: #404040;
  --base-font-family: Roboto, Helvetica, Arial, sans-serif;
  --base-font-size: 1.4rem;
  --base-font-color: #404040;
  --base-font-weight: 400;
  --base-line-height: 1.4;
  --box-shadow-1: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.12);
  --box-shadow-2: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.11);
  --box-shadow-3: 0 10px 20px rgba(0, 0, 0, 0.17), 0 6px 6px rgba(0, 0, 0, 0.11);
  --box-shadow-4: 0 14px 28px rgba(0, 0, 0, 0.13), 0 10px 10px rgba(0, 0, 0, 0.1);
  --box-shadow-5: 0 19px 38px rgba(0, 0, 0, 0.18), 0 15px 12px rgba(0, 0, 0, 0.1);
  --base-border-radius: 0.4rem;
}

[kremling="i11"] .company-list,[kremling="i11"].company-list {
  padding: 2rem;
}

[kremling="i11"] .company-list table button,[kremling="i11"].company-list table button {
  opacity: 0;
}
[kremling="i11"] .company-list table tr:hover button,[kremling="i11"].company-list table tr:hover button {
  opacity: 1;
}

[kremling="i11"] .company-list__address,[kremling="i11"].company-list__address {
  font-size: 12px;
}

[kremling="i11"] .invalid-input,[kremling="i11"].invalid-input {
  margin-bottom: 0px;
  color: red;
}

/* The switch - the box around the slider */
[kremling="i11"] .switch,[kremling="i11"].switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
[kremling="i11"] .switch input,[kremling="i11"].switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
[kremling="i11"] .slider,[kremling="i11"].slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #df5651;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

[kremling="i11"] .slider:before,[kremling="i11"].slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

[kremling="i11"] input:checked+.slider,input[kremling="i11"]:checked+.slider {
  background-color: #73b56e;
}

[kremling="i11"] input:focus+.slider,input[kremling="i11"]:focus+.slider {
  box-shadow: 0 0 1px #73b56e;
}

[kremling="i11"] input:checked+.slider:before,input[kremling="i11"]:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
[kremling="i11"] .slider.round,[kremling="i11"].slider.round {
  border-radius: 34px;
}

[kremling="i11"] .slider.round:before,[kremling="i11"].slider.round:before {
  border-radius: 50%;
}

[kremling="i11"] .companyActive>.isActive,[kremling="i11"].companyActive>.isActive {
  fill: #73b56e;
}

[kremling="i11"] .companyActive>.isNotActive,[kremling="i11"].companyActive>.isNotActive {
  fill: #df5651 !important;
}

[kremling="i11"] .filter,[kremling="i11"].filter {
  display: inline-block !important;
  border: solid 1px #d3d3d3;
  line-height: 1;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 1.4rem;
  color: #404040;
  border-radius: 0.4rem;
  padding: 0 1rem;
  transition: border-color 200ms ease, background-color 200ms ease, box-shadow 200ms ease;
  height: 3rem;
  background-color: #fff;
}
[kremling="i11"] .filter:focus,[kremling="i11"].filter:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.22rem rgba(72, 122, 174, 0.25);
  background-color: #fff;
  outline: none;
  color: #495057;
}
[kremling="i11"] .filter.inline,[kremling="i11"].filter.inline {
  width: auto;
  display: inline-block;
}
[kremling="i11"] .filter.transparent,[kremling="i11"].filter.transparent {
  border-color: transparent;
  background-color: transparent;
}

[kremling="i11"] .brand,[kremling="i11"].brand {
  position: relative;
}

[kremling="i11"] .brand-close,[kremling="i11"].brand-close {
  position: absolute;
  right: 2.8rem;
  top: 0.4rem;
}`,
  id: 'i11',
  namespace: 'kremling'
};